import { useState } from "react";
import { Copy } from "lucide-react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export function TokenDialog({
  isOpen,
  onOpenChange,
  deviceName,
  tokenType,
  token,
}) {
  const [copiedToken, setCopiedToken] = useState(false);

  const isTokenUnavailable = !token || token.trim() === "-";

  const copyTokenToClipboard = async () => {
    if (isTokenUnavailable) return;

    try {
      await navigator.clipboard.writeText(token);
      setCopiedToken(true);
      window.setTimeout(() => setCopiedToken(false), 1600);
    } catch {
      setCopiedToken(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>{deviceName || "Device"}</DialogTitle>
          <DialogDescription>
            {`${deviceName || "Device"} Token (${tokenType || "web"})`}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3">
          <Label>Token</Label>
          <div className="rounded-md border border-gray-700 text-white px-3 py-2 text-xs font-mono break-all text-foreground">
            {token || "-"}
          </div>
        </div>

        <div className="mt-5 flex justify-end">
          <Button
            type="button"
            variant=""
            onClick={copyTokenToClipboard}
            disabled={isTokenUnavailable}
          >
            <Copy />
            {copiedToken ? "Copied" : "Copy"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
